import { generateNaturalData } from 'src/utils/util';

const startDate = new Date('2025-05-17T00:00:00');
const endDate = new Date('2025-05-21T00:00:00');
const intervalHours = 1;

const lineChart = {
  series: [
    {
      name: 'Product A',
      data: generateNaturalData(startDate, endDate, intervalHours, 1.0, 1.2),
    },
    {
      name: 'Product B',
      data: generateNaturalData(startDate, endDate, intervalHours, 0.9, 1.3),
    },
  ],

  options: {
    chart: {
      width: '100%',
      height: 350,
      type: 'line',
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
        allowMouseWheelZoom: false,
      },
    },

    legend: {
      show: true,
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
      width: 2,
    },

    colors: [
      '#2E93fA', // Blue
      '#66DA26', // Green
      '#FF9800', // Orange
      '#E91E63', // Pink
      '#546E7A', // Gray
      '#775DD0', // Purple
      '#87CEEB', // Sky Blue
      '#FFD700', // Gold
      '#00E396', // Light Green
      '#FF0000', // Bright Red
      '#F9C80E', // Yellow
    ],

    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 600,
          colors: ['#8c8c8c'],
        },
      },
    },

    xaxis: {
      type: 'datetime',
      labels: {
        datetimeFormatter: {
          year: 'yyyy',
          month: 'MMM yyyy',
          day: 'MM/dd',
          hour: 'HH:mm',
        },
        style: {
          fontSize: '14px',
          fontWeight: 600,
        },
      },
    },

    tooltip: {
      x: {
        format: 'yyyy-MM-dd HH:mm',
      },
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
  },
};

export default lineChart;
